module.exports = __webpack_public_path__ + "img/question.4202a453.png";